export const buttonStylingTailwind =
  'h-6 break-normal text-size-body-sm rounded-sm py-1.5 md:px-3 px-1.5 md:gap-1.5 gap-4 w-full md:w-auto md:justify-center justify-start';
export const iconStylingTailwind = 'w-4 h-4 md:w-3 md:h-3 text-text-dark';
export const iconLargerStylingTailwind = 'w-4 h-4 text-text-dark';
export const inlineButtonStyleTailwind =
  'col-span-3 md:col-start-2 md:col-span-1 py-0 mb-2 row-start-8 md:row-start-5 md:row-span-1 block md:hidden w-full min-h-[38px] h-[38px] enabled:hover:border-color-text-darktransparent';
export const addToBasketStyleOverridesGalleryViewTailwind =
  'p-0 w-4.5 md:w-4.5 h-4.5 min-h-4.5 bg-color-grey-light md:px-0';
